module.exports = __webpack_public_path__ + "static/media/sheco.177da663.svg";